import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useShareComponentEntryMutation, getComponentEntryQueryKey } from '@utils/component-framework';

function useShareWithTeacherAction(entryKey, onShared) {
  const queryClient = useQueryClient();
  const shareComponentEntry = useShareComponentEntryMutation();
  return useCallback(() => {
    const entry = queryClient.getQueryData(getComponentEntryQueryKey(entryKey));
    shareComponentEntry.mutate({
      entry,
      message: undefined
    });
    onShared?.();
  }, [entryKey, onShared, queryClient, shareComponentEntry]);
}

export { useShareWithTeacherAction };
//# sourceMappingURL=share.js.map
